import { type FC } from 'react';
import { useSelector } from 'react-redux';
import { PapiUser } from '@wix/da-papi-types';
import CoreBanner from './CoreBanner';
import { getCoreLevel } from '@wix/da-shared-react/pkg/publicSession/selectors';
import cn from 'classnames';
import VideoCreatorControls from './VideoCreatorControls';
import VideoCreatorFiles from './VideoCreatorFiles';

import s from './VideoCreator.scss';

export interface Props {
  currentUser?: PapiUser;
}

const VideoCreator: FC<Props> = ({ currentUser }) => {
  const coreLevel = useSelector(getCoreLevel);
  const showCoreBanner = coreLevel !== 'core_max';

  return (
    <div className={s['root']}>
      <CoreBanner currentUser={currentUser} />
      <div
        className={cn(s['main-interface'], showCoreBanner && s['space-for-cb'])}
      >
        <VideoCreatorControls />
        <VideoCreatorFiles />
      </div>
    </div>
  );
};

VideoCreator.displayName = 'VideoCreator';
export default VideoCreator;
